module.exports = __webpack_public_path__ + "img/invitation3.3f7e2760.png";